import { FC, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { App } from '@capacitor/app'

import { Login } from '@components/templates/login'
import { Footer } from '@/components/organisms/Footer'

import { appConfig } from '@/services/config'
import { Tracking, TrackingEvent } from '@/lib/tracking'
import { isNativeIOS } from '@/utils/utils'

import { AuthFlow, Pages } from '@/enums'

import SignInWithEmail from './Email/SignInWithEmail'
import SignInWithPhoneNumber from './SMS/SignInWithPhoneNumber'
import SignInWithApple from './SSO/SignInWithApple'
import SignInWithFacebook from './SSO/SignInWithFacebook'
import SignInWithGoogle from './SSO/SignInWithGoogle'

export type ILogInOptions = RouteComponentProps

App.addListener('resume', () => {
  const pathname = window.location.pathname
  pathname === `/${Pages.LogIn}` &&
    Tracking.triggerEvent(TrackingEvent.LogInViewed)
})

export const LogInOptions: FC<ILogInOptions> = ({ history }) => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const { pathname = '' } = location

  useEffect(() => {
    pathname === `/${Pages.LogIn}` &&
      Tracking.triggerEvent(TrackingEvent.LogInViewed)
  }, [pathname])

  const title = (
    <Trans i18nKey="registration.logInOptions.title">
      {t('registration.logInOptions.title')}
    </Trans>
  )

  return (
    <Login title={title} backButton>
      <SignInWithEmail authFlow={AuthFlow.LogIn} history={history} />
      <SignInWithPhoneNumber history={history} />
      <br />
      {Boolean(appConfig.ssoVisible) && (
        <SignInWithGoogle authFlow={AuthFlow.LogIn} history={history} />
      )}
      {Boolean(appConfig.ssoVisible) && isNativeIOS() && (
        <SignInWithApple authFlow={AuthFlow.LogIn} history={history} />
      )}
      {Boolean(appConfig.ssoVisible) && (
        <SignInWithFacebook authFlow={AuthFlow.LogIn} history={history} />
      )}

      <Footer className="mt-auto pt-4 pb-4" />
    </Login>
  )
}
